// eslint-disable-next-line import/no-anonymous-default-export
export default [
  {
    name: "Salesforce Development",
    description: "Apex, Visualforce, Lightning Web Components, SOQL, SOSL, Platform Events, REST API, SOAP API, Bulk API",
  },
  {
    name: "Web Technologies",
    description: "HTML, CSS, JavaScript, JSON, XML, BEM, SCSS",
  },
    {
    name: "Salesforce Tools",
    description: "Workbench, DataLoader, Copado",
  },
  {
    name: "Other Salesforce Solutions",
    description: "Conga, DocuSign, B2B Commerce",
  },
  {
    name: "Project Management",
    description: "Jira",
  },
  {
    name: "Version Control",
    description: "Git",
  },
  {
    name: "Additional Skills",
    description: "Microsoft Excel, Adobe Photoshop, and a dash of creativity :)",
  },
  {
    name: "Certifications",
    description: "\n Platform Developer I \n JavaScript Developer  \n Administrator \n Integration Architect",

  },
  {
    name: "English Skills",
    description: "Upper Intermediate B2",
  },
  {
    name: "Education",
    description: "Bachelor of Science in Computer Science, Belarusian State University of Informatics and Radioelectronics, Minsk",
  },
];
